import {Box} from "@mui/material";

interface LanguageLabelProps {
    /* Language name and the flag icon filename from the languages table. */

    language: string;
    flag?: string | null;
}

// LANGUAGE LABEL
export default function LanguageLabel({language, flag}: LanguageLabelProps) {
    /**
     * Shows a country flag beside a language name.
     */

    return (
        <Box component="span" sx={{display: "inline-flex", alignItems: "center", gap: 1}}>
            {flag ? (
                <Box
                    component="img"
                    src={`/images/flags/${flag}`}
                    alt=""
                    sx={{
                        width: 20,
                        height: 15,
                        objectFit: "cover",
                        borderRadius: "2px",
                        flexShrink: 0,
                    }}
                />
            ) : null}
            {language}
        </Box>
    );
}
